document.querySelectorAll('.custom-input-wrapper select[data-assigned-to]').forEach(e=> {
    document.querySelectorAll('.custom-input-wrapper').forEach(c=> {
        if( c.dataset.setLabel == e.dataset.assignedTo )  {
            c.querySelector('select')?.setAttribute('data-connect', e.closest('.custom-input-wrapper').dataset.setLabel)
        }
    })
})

document.querySelectorAll('.custom-input-wrapper select').forEach(e=> {
    e.addEventListener('change', function(evt) {
        const selectedIndex = e.selectedIndex;
        const selectedOpt = e.options[selectedIndex]
        const parent = e.closest('.custom-input-wrapper')
        const priceEl = document.querySelector('.dynamic-pricing')

        if (e.hasAttribute('data-connect')) {

            let connected = document.querySelector(`.custom-input-wrapper[data-set-label="${e.dataset.connect}"]`)

            if (selectedOpt.value != '') {
                connected.removeAttribute('hidden')
                connected.querySelector('select').setAttribute('required', '')
                connected.classList.add('required-input')
            } else { 
                connected.setAttribute('hidden','')
                connected.querySelector('select').removeAttribute('required')
                connected.classList.remove('required-input')
            }
        }

        if (selectedOpt.value != '') {
            if (parent.classList.contains('required-input')) {
                parent.classList.remove('error')
            }
        } else { 
            if (parent.classList.contains('required-input')) {
                parent.classList.add('error')
            }
        }

        if (priceEl) {
            priceUpdate(Number(priceEl.dataset.currentPrice))
        }
    })
})

subscribe(PUB_SUB_EVENTS.variantChange, (eventData) => {
    const variant = eventData.data.variant;

    priceUpdate(variant.price)
});

function priceUpdate(variantPrice) {
    const addonInputs = document.querySelectorAll('.custom-input-wrapper select option[data-variant]:checked')
    const priceEl = document.querySelector('.dynamic-pricing')
    const symbol = priceEl.dataset.currencySymbol
    var addonTotal = 0

    if (!variantPrice) return;

    addonInputs.forEach(addon=> {
        addonTotal += Number(addon.dataset.price)
    })

    if (!priceEl || !priceEl.querySelector('.price-item--regular')) return;

    if (addonInputs.length == 0) {
        priceEl.querySelector('.price-item--regular').textContent = symbol + moneyFormatter(variantPrice) + ' ' + Shopify.currency['active']
    } else { 
        priceEl.querySelector('.price-item--regular').textContent = symbol + moneyFormatter(variantPrice + addonTotal) + ' ' + Shopify.currency['active']
    }
}

function moneyFormatter(variantPrice) {
    const formattedPrice = (variantPrice / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return formattedPrice.endsWith('.00') ? formattedPrice.slice(0, -3) : formattedPrice;
}